import { OperationTypeEnum, QaQcTestResultEnum, RejectionReasonsEnum, ShiftsEnum } from "@gtpl/shared-models/common-models";
import { BaseEntity, Column, Entity, Index, JoinColumn, JoinTable, ManyToMany, ManyToOne, OneToMany, OneToOne, PrimaryColumn, PrimaryGeneratedColumn, RelationId, VersionColumn, UpdateDateColumn, CreateDateColumn } from "typeorm";
@Entity('soaking')
export class Soaking {

  @PrimaryGeneratedColumn("increment", { name: 'soaking_id' })
  soakingId: number;

  @Column('int', {
    nullable: false,
    name: "plant_id"
  })
  plantId: number;

  @Column('int', {
    nullable: false,
    name: "assert_id"
  })
  assertId: number;
  @Column('int', {
    nullable: false,
    name: "duration"
  })
  duration: number;
  @Column("varchar", {
    nullable: true,
    length: 50,
    name: "start_time"
    })
    StartTime: string;
    @Column("varchar", {
    nullable: true,
    length: 50,
    name: "end_time"
    })
    EndTime: string;
    @Column("datetime", {
    nullable: true,
    name: "date"
    })
    date: Date;
  
  @Column("boolean", {
    nullable: false,
    default: true,
    name: "is_active"
  })
  isActive: boolean;
  
  @CreateDateColumn({
    name: "created_at",
    type: "datetime"
  })
  createdAt: Date;

  @Column("varchar", {
    nullable: true,
    name: "created_user"
  })
  createdUser: string | null;

  @UpdateDateColumn({
    name: "updated_at",
    type: 'datetime'
  })
  updatedAt: Date;

  @Column("varchar", {
    nullable: true,
    name: "updated_user"
  })
  updatedUser: string | null;

  @VersionColumn({
    default: 1,
    name: "version_flag"
  })
  versionFlag: number;
 
}